import { createContext } from 'react';
const LayoutGroupContext = createContext({});
export { LayoutGroupContext };